import { useState, useEffect, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

export const Navigation = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { path: "/", label: "Accueil" },
    { path: "/collections", label: "Nos Collections" },
    { path: "/personnalisation", label: "Sur Mesure" },
    { path: "/a-propos", label: "À Propos" },
    { path: "/contact", label: "Contact" },
  ];

  const navBg = isScrolled
    ? "bg-[#F9F9F7]/95 backdrop-blur-md shadow-sm"
    : "bg-[#F9F9F7]";

  const textColor = "text-[#1A1A1A]";

  return (
    <>
      <nav
        data-testid="main-navigation"
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${navBg}`}
      >
        <div className="container-premium">
          <div className="flex items-center justify-between h-20 md:h-24">
            {/* Logo */}
            <Link
              to="/"
              data-testid="nav-logo"
              className="flex items-center"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_lunettes-sur-mesure/artifacts/l7tvoctv_OpticienDeVaires_Logo1_Transparent.png"
                alt="Opticien de Vaires"
                className="h-16 md:h-24 w-auto transition-all duration-300"
              />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center gap-10">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  data-testid={`nav-link-${link.path.replace("/", "") || "home"}`}
                  className={`nav-link ${textColor} ${
                    location.pathname === link.path ? "text-[#D4AF37]" : ""
                  }`}
                >
                  {link.label}
                </Link>
              ))}
              <Link
                to="/contact"
                data-testid="nav-rdv-button"
                className="btn-primary text-xs py-3 px-6"
              >
                Prendre RDV
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              data-testid="mobile-menu-toggle"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`md:hidden ${textColor} p-2`}
              aria-label="Menu"
            >
              {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div
          data-testid="mobile-menu"
          className="mobile-menu"
        >
          <button
            onClick={() => setIsMobileMenuOpen(false)}
            className="absolute top-6 right-6 text-[#1A1A1A]"
            aria-label="Fermer"
          >
            <X size={24} />
          </button>
          {navLinks.map((link, index) => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`mobile-nav-link-${link.path.replace("/", "") || "home"}`}
              className={`nav-link text-[#1A1A1A] text-2xl animate-fade-in-up`}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            data-testid="mobile-nav-rdv-button"
            className="btn-primary mt-4 animate-fade-in-up"
            style={{ animationDelay: "400ms" }}
          >
            Prendre Rendez-vous
          </Link>
        </div>
      )}
    </>
  );
};
